import { message } from 'antd'
import api from '../../utils/api'
import { fetchInvestorUserLogout, SET_PROFILE_DATA } from '../auth/authActions'
import * as actionTypes from './ActionTypes'

export const UPDATE_STEP = 'UPDATE_STEP'
export const UPDATE_TAB = 'UPDATE_TAB'
export const LOGIN_FAILED = 'LOGIN_FAILED'
export const SIGNUP_FAILED = 'SIGNUP_FAILED'
export const UPDATE_USER_INFO_FAILED = 'UPDATE_USER_INFO_FAILED'
export const DID_ENTER_REGISTER_PAGE = 'DID_ENTER_REGISTER_PAGE'
export const RECEIVE_USER_PROFILE = 'RECEIVE_USER_PROFILE'
export const EDIT_PHOTO_START = 'EDIT_PHOTO_START'
export const RECEIVE_USER_IMAGE = 'RECEIVE_USER_IMAGE'
export const UPDATE_INDEX = 'UPDATE_INDEX'
export const USER_IMAGE = 'USER_IMAGE'
export const SET_RATIONALE_REASON = 'SET_RATIONALE_REASON'
export const SET_RATIONALE_EXPLANATION = 'SET_RATIONALE_EXPLANATION'
export const SET_PASS_DEAL_REASON = 'SET_PASS_DEAL_REASON'
export const SET_PASS_DEAL_ISSUE = 'SET_PASS_DEAL_ISSUE'
export const SET_PASS_DEAL_FEEDBACK = 'SET_PASS_DEAL_FEEDBACK'
export const SET_PASS_DEAL_SUBMIT_PAGE = 'SET_PASS_DEAL_SUBMIT_PAGE'
export const SET_US_SSN = 'SET_US_SSN'
export const SET_INVESTMENT_VALUE = 'SET_INVESTMENT_VALUE'
export const SET_INVESTOR_INFO = 'SET_INVESTOR_INFO'
export const SET_INVESTOR_INFO_NO_SSN = 'SET_INVESTOR_INFO_NO_SSN'
export const SET_ACCREDITION_TYPE = 'SET_ACCREDITION_TYPE'
export const SET_INVESTOR_LEGAL_NAME_INFO = 'SET_INVESTOR_LEGAL_NAME_INFO'
export const SET_INVESTOR_BANK_ID = 'SET_INVESTOR_BANK_ID'
export const REMOVE_ACCOUNT_ERROR = 'REMOVE_ACCOUNT_ERROR'
export const REMOVE_POST_MONEY_ERROR = 'REMOVE_POST_MONEY_ERROR'
export const ADD_INVESTING_STEPS_DATA = 'ADD_INVESTING_STEPS_DATA'
export const REMOVE_INVESTING_STEPS_DATA = 'REMOVE_INVESTING_STEPS_DATA'
export const ADD_ALL_INVESTING_STEPS_DATA = 'ADD_ALL_INVESTING_STEPS_DATA'

export const setPassDealReason = text => ({
  type: 'SET_PASS_DEAL_REASON',
  payload: text,
})

export const setRationaleReason = text => ({
  type: 'SET_RATIONALE_REASON',
  payload: text,
})
export const setRationaleExplanation = text => ({
  type: SET_RATIONALE_EXPLANATION,
  payload: text,
})

export const clearRationale = () => ({
  type: 'CLEAR_RATIONALE',
})

export const setPassDealIssue = text => ({
  type: 'SET_PASS_DEAL_ISSUE',
  payload: text,
})

export const setPassDealFeedback = text => ({
  type: 'SET_PASS_DEAL_FEEDBACK',
  payload: text,
})

export const setPassDealAnonymous = text => ({
  type: 'SET_PASS_DEAL_ANONYMOUS',
  payload: text,
})

export const setPassDealSubmitPage = bool => ({
  type: 'SET_PASS_DEAL_SUBMIT_PAGE',
  payload: bool,
})
export const setInvestorName = text => ({
  type: 'SET_INVESTOR_NAME',
  payload: text,
})

export const setUsSSN = bool => ({
  type: 'SET_US_SSN',
  payload: bool,
})

export const clearPassDeal = () => ({
  type: 'CLEAR_PASS_DEAL',
})

export const setConfirmedEmail = () => ({
  type: 'SET_CONFIRMED_EMAIL',
})

export const nextStep = () => ({
  type: 'NEXT_STEP',
})

export const nextStepInvestor = () => ({
  type: 'NEXT_STEP_INVESTOR',
})

export const prevStep = () => ({
  type: 'PREV_STEP',
})

export const prevStepInvestor = () => ({
  type: 'PREV_STEP_INVESTOR',
})

export const initialState = () => ({
  type: 'RESET_INITIAL_STATE',
})

export const toggleLogoToHome = () => ({
  type: 'RETURN_HOME_PAGE',
})

export const setSearchField = text => {
  return { type: 'CHANGE_SEARCHFIELD', payload: text }
}

export const setInputField = text => {
  return { type: 'ANGELGROUP_INPUT', payload: text }
}

export const setSyndicateField = text => {
  return { type: 'ADDED_SYNDICATE_GROUP', payload: text }
}

export const isClickedToShowForm = () => ({
  type: 'SHOW_SYNDICATE_FORM',
})

export const removedSyndicate = () => ({
  type: 'HIDE_SYNDICATE_FORM',
})

export const resetChildLocalStatesInInvestorProfileEdit = value => {
  return {
    type: 'RESET_LOCAL_CHILD_STATES_IN_INVESTOR_PROFILE_EDIT',
    payload: value,
  }
}

export const updateStep = stepInvestor => ({
  type: UPDATE_STEP,
  payload: stepInvestor,
})

export const updateTab = tabInvestor => ({
  type: UPDATE_TAB,
  payload: tabInvestor,
})

export const investorLoginFailed = () => ({
  type: LOGIN_FAILED,
})

export const investorSignupFailed = () => ({
  type: SIGNUP_FAILED,
})

export const updateUserInfoFailed = () => ({
  type: UPDATE_USER_INFO_FAILED,
})

export const didEnterRegisterPage = () => ({
  type: DID_ENTER_REGISTER_PAGE,
})

export const receiveUserProfile = data => ({
  type: RECEIVE_USER_PROFILE,
  payload: data,
})
export const receiveUserImage = data => ({
  type: RECEIVE_USER_IMAGE,
  payload: data,
})

export const updateMondayNotifications = data => ({
  type: 'UPDATE_INV_MONDAY_NOTIFICATIONS',
  payload: data,
})

export const updateIndex = () => ({
  type: UPDATE_INDEX,
})

export const setHistorySelection = selection => ({
  type: 'SET_INV_HISTORY_SELECTION',
  payload: selection,
})

export const setDiscoverView = () => ({
  type: 'SET_INV_DISCOVER_VIEW',
})

export const setHistoryView = () => ({
  type: 'SET_INV_HISTORY_VIEW',
})

export const setInvitedStartup = data => ({
  type: 'SET_INVITED_STARTUP',
  payload: data,
})

export const removeStartup = () => ({
  type: 'REMOVE_STARTUP',
})

export const loadingDashboard = loading => ({
  type: 'LOAD_INV_DASHBOARD',
  payload: loading,
})

export const receiveUserHistoryCardInfo = data => ({
  type: 'RECEIVE_INV_USER_HISTORY_CARD_INFO',
  payload: data,
})

export const getInvestorDeals = (data, page, totalCount) => ({
  type: 'GET_INVESTOR_DEALS',
  payload: data,
  page,
  totalCount,
})

export const setInvestorLoader = () => ({
  type: 'SET_INVESTOR_LOADER',
})

export const setHideInvestorLoader = () => ({
  type: 'SET_HIDE_INVESTOR_LOADER',
})

export const getInvestorDealsList = (data, page, totalCount) => ({
  type: 'GET_INVESTOR_DEALS_LIST',
  payload: data,
  page,
  totalCount,
})

export const clearInvestorDeals = () => ({
  type: 'CLEAR_INVESTOR_DEALS',
})

export const setHideInvestorLoadButton = data => ({
  type: 'SET_HIDE_INVESTOR_LOAD_BUTTON',
  payload: data,
})

export const getInvestorDealDetail = data => ({
  type: 'GET_INVESTOR_DEAL_DETAIL',
  payload: data,
})

export const setInvestorDealQuestionLoader = data => ({
  type: 'SET_INVESTOR_DEAL_QUESTION_LOADER',
  payload: data,
})

export const getInvestorDealQuestion = data => ({
  type: 'GET_INVESTOR_DEAL_QUESTION',
  payload: data,
})

export const getInvestorMonthlyUpdates = data => ({
  type: 'GET_INVESTOR_MONTHLY_UPDATES',
  payload: data,
})

export const getInvestorMonthlyUpdatesMetricData = data => ({
  type: 'GET_INVESTOR_MONTHLY_UPDATES_METRIC_DATA',
  payload: data,
})

export const getInvestorPassedDeals = (data, count) => ({
  type: 'GET_INVESTOR_PASSED_DEALS',
  payload: data,
  totalCount: count,
})

export const investingStepsLoader = data => ({
  type: 'INVESTING_STEPS_LOADING',
  payload: data,
})


export const SaveAndExitClicked = data => ({
  type: 'Save_And_Exit_Clicked',
  payload: data,
})
export const SaveAndExitClickedReset = data => ({
  type: 'Save_And_Exit_Clicked_Reset',
  payload: data,
})

export const setInvestmentValue = data => ({
  type: 'SET_INVESTMENT_VALUE',
  payload: data,
})

export const setInvestorInfo = data => ({
  type: 'SET_INVESTOR_INFO',
  payload: data,
})

export const setInvestorInfoNoSSN = data => ({
  type: 'SET_INVESTOR_INFO_NO_SSN',
  payload: data,
})

export const setInvestorLegalNameInfo = data => ({
  type: 'SET_INVESTOR_LEGAL_NAME_INFO',
  payload: data,
})

export const setInvestorBankId = data => ({
  type: 'SET_INVESTOR_BANK_ID',
  payload: data,
})

export const setInvestmentInvestingAs = data => ({
  type: 'SET_INVESTMENT_INVESTING_AS',
  payload: data,
})

export const setInvestmentInvestorName = data => ({
  type: 'SET_INVESTMENT_INVESTOR_NAME',
  payload: data,
})

export const setAccreditionType = data => ({
  type: 'SET_ACCREDITION_TYPE',
  payload: data,
})
export const setLocalAccreditionLevel = data => ({
  type: 'SET_LOCAL_ACCREDITION_LEVEL',
  payload: data,
})

export const removeAccountError = () => ({
  type: 'REMOVE_ACCOUNT_ERROR',
})

export const removePostMoneyError = () => ({
  type: 'REMOVE_POST_MONEY_ERROR',
})

export const isDoneStatus = () => {
  return async dispatch => {
    dispatch({
      type: actionTypes.DONE_SUCCESS,
    })
  }
}

export const isDebounceLoader = data => {
  return async dispatch => {
    dispatch({
      type: actionTypes.IS_DEBOUNCE_LOADER,
      payload: data,
    })
  }
}

/** Dispatches the provided tax information data to the store. */
export const setTaxInformationData = data => {
  return async dispatch => {
    dispatch({
      type: actionTypes.TAX_INFORMATION_DATA,
      payload: data,
    })
  }
}

/** Sets the current selected item in the store. */
export const setCurrent = data => {
  return async dispatch => {
    dispatch({
      type: actionTypes.SET_CURRENT,
      payload: data,
    })
  }
}

/** Fetches the completed tour status for the investor and updates the store. */
export const getCompletedTour = () => {
  return async dispatch => {
    dispatch({
      type: actionTypes.GET_COMPLETED_TOUR_INIT,
    })
    await api
      .get(`${process.env.REACT_APP_API_URL}/investor/tour-completed`, undefined, 'investor')
      .then(res => {
        dispatch({
          type: actionTypes.GET_COMPLETED_TOUR_SUCCESS,
          payload: res,
        })
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.GET_COMPLETED_TOUR_FAILED,
        })
        throw error?.response?.data?.error || error?.message
      })
  }
}

/** Retrieves tour token data based on the provided input. */
export const getTourTokenData = data => {
  return async dispatch => {
    dispatch({
      type: actionTypes.GET_TOUR_TOKEN_INIT,
    })
    await api
      .post(`${process.env.REACT_APP_API_URL}/investor/login`, data, 'investor')
      .then(res => {
        dispatch({
          type: actionTypes.GET_TOUR_TOKEN_SUCCESS,
          payload: res,
        })
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.GET_TOUR_TOKEN_FAILED,
        })
        throw error?.response?.data?.error || error?.message
      })
  }
}

/** Fetches the user's profile data with optional pagination offset. */
export const fetchUserProfile = offsetVal => {
  return dispatch => {
    return api
      .get(`${process.env.REACT_APP_API_URL}/startup/get-users/` + offsetVal, undefined, 'investor')
      .then(res => {
        let data = res.data
        if (res.result) {
          dispatch(receiveUserProfile(data))
          return true
        } else {
          if (res.error === 'token expired' && res.is_expired) {
            dispatch(fetchInvestorUserLogout())
            dispatch({
              type: 'SET_AUTH_EXPIRED',
            })
          }
          return false
        }
      })
  }
}

export const editPhotoStart = () => {
  return {
    type: EDIT_PHOTO_START,
  }
}

/** Uploads and updates the user's profile photo with the given file. */
export const editPhoto = file => {
  return dispatch => {
    dispatch(editPhotoStart())
    return api
      .sendFile(`${process.env.REACT_APP_API_URL}/investor/mime-files`, file, 'image', 'investor')
      .then(res => {
        if (res.result) {
          dispatch(receiveUserImage(res.url))
          return true
        } else {
          if (res.error === 'token expired' && res.is_expired) {
            dispatch(fetchInvestorUserLogout())
            dispatch({
              type: 'SET_AUTH_EXPIRED',
            })
          }
          return false
        }
      })
  }
}


/** Initiates the process to change the user's password. */
export const changePassword = () => {
  return dispatch => {
    return api
      .get(`${process.env.REACT_APP_API_URL}/investor/change-password`, undefined, 'investor')
      .then(res => {
        if (res.result) {
          dispatch(fetchInvestorUserLogout())
        } else {
          if (res.error === 'token expired' && res.is_expired) {
            dispatch(fetchInvestorUserLogout())
            dispatch({
              type: 'SET_AUTH_EXPIRED',
            })
          }
          return false
        }
      })
  }
}

/** Fetches detailed card information for a specific user history item by ID. */
export const fetchUserHistoryCardInfo = id => {
  return dispatch => {
    return api
      .post(
        `${process.env.REACT_APP_API_URL}/investor/startup-detail`,
        {
          id,
        },
        'investor',
      )
      .then(res => {
        if (res.result) {
          dispatch(receiveUserHistoryCardInfo(res.data))
          return res.data
        } else {
          if (res.error === 'token expired' && res.is_expired) {
            dispatch(fetchInvestorUserLogout())
            dispatch({
              type: 'SET_AUTH_EXPIRED',
            })
          }
          return false
        }
      })
  }
}

/** Retrieves investor deals based on the provided data and type. */
export const fetchInvestorDeals = (data, type) => {
  return dispatch => {
    dispatch(setInvestorLoader())
    return api
      .post(
        `${process.env.REACT_APP_API_URL}/investor/get-relevant-startups`,
        {
          page_num: data,
          page_size: 5,
          deals_type: type,
        },
        'investor',
      )
      .then(res => {
        if (res.result) {
          if (!res?.data?.length) {
            dispatch(setHideInvestorLoadButton(true))
          } else {
            dispatch(setHideInvestorLoadButton(false))
          }
          if (data === 1) {
            dispatch(getInvestorDealsList(res.data, data + 1, res.total_count))
          } else {
            dispatch(getInvestorDeals(res.data, data + 1, res.total_count))
          }
          return res
        } else {
          dispatch(setHideInvestorLoader())
          if (res.error === 'token expired' && res.is_expired) {
            dispatch(fetchInvestorUserLogout())
            dispatch({
              type: 'SET_AUTH_EXPIRED',
            })
          }
          return false
        }
      })
  }
}

/** Processes the investor's action to pass on a deal. */
export const investorPassDeal = (data, onSuccess, onError) => {
  return dispatch => {
    return api.post(`${process.env.REACT_APP_API_URL}/investor/pass-startup`, data, 'investor').then(res => {
      if (res.result) {
        dispatch(setPassDealSubmitPage(true))
        if (res.karma_points !== undefined) {
          dispatch({
            type: SET_PROFILE_DATA,
            payload: { data: { karma_points: res.karma_points } },
          })
        }
        onSuccess(res)
        return res
      } else {
        onError(res)
        if (res.error === 'token expired' && res.is_expired) {
          dispatch(fetchInvestorUserLogout())
          dispatch({
            type: 'SET_AUTH_EXPIRED',
          })
        }
        return false
      }
    })
  }
}

/** Fetches detailed information for a specific investor deal by ID. */
export const fetchInvestorDealDetail = id => {
  return dispatch => {
    return api
      .post(
        `${process.env.REACT_APP_API_URL}/investor/startup-detail`,
        {
          id,
        },
        'investor',
      )
      .then(res => {
        if (res.result) {
          dispatch(getInvestorDealDetail(res.data))
          return res.data
        } else {
          if (res.error === 'token expired' && res.is_expired) {
            dispatch(fetchInvestorUserLogout())
            dispatch({
              type: 'SET_AUTH_EXPIRED',
            })
          }
          return false
        }
      })
  }
}

/** Retrieves questions related to an investor deal by ID, with pagination and type filtering. */
export const fetchInvestorDealQuestions = (id, page, type) => {
  return dispatch => {
    dispatch(setInvestorDealQuestionLoader(true))
    return api
      .post(
        `${process.env.REACT_APP_API_URL}/investor/get-questions?id=${id}`,
        {
          page_num: page,
          page_size: 5,
          question_type: type,
        },
        'investor',
      )
      .then(res => {
        if (res.result) {
          dispatch(getInvestorDealQuestion(res.data))
          return res
        } else {
          dispatch(setInvestorDealQuestionLoader(false))
          if (res.error === 'token expired' && res.is_expired) {
            dispatch(fetchInvestorUserLogout())
            dispatch({
              type: 'SET_AUTH_EXPIRED',
            })
          }
          return false
        }
      })
  }
}

/** Submits a new question related to an investor deal. */
export const postInvestorDealQuestions = data => {
  return dispatch => {
    return api
      .post(
        `${process.env.REACT_APP_API_URL}/investor/post-question`,
        {
          question: data.question,
          startup_id: data.id,
          is_anonymous: data.is_anonymous,
        },
        'investor',
      )
      .then(res => {
        if (res.result) {
          return res
        } else {
          if (res.error === 'token expired' && res.is_expired) {
            dispatch(fetchInvestorUserLogout())
            dispatch({
              type: 'SET_AUTH_EXPIRED',
            })
          }
          return false
        }
      })
  }
}

/** Fetches monthly updates for a specific investor deal by ID. */
export const fetchInvestorMonthlyUpdates = id => {
  return dispatch => {
    return api
      .get(`${process.env.REACT_APP_API_URL}/investor/get-monthly-updates?id=${id}`, undefined, 'investor')
      .then(res => {
        if (res.result) {
          dispatch(getInvestorMonthlyUpdates(res.data))
          return res
        } else {
          if (res.error === 'token expired' && res.is_expired) {
            dispatch(fetchInvestorUserLogout())
            dispatch({
              type: 'SET_AUTH_EXPIRED',
            })
          } else {
            dispatch(getInvestorMonthlyUpdates([]))
          }
          return false
        }
      })
  }
}

/** Submits metric data for plotting related to a specific deal or entity by ID. */
export const postMetricDataPlot = (id, data) => {
  return dispatch => {
    return api
      .post(
        `${process.env.REACT_APP_API_URL}/investor/metric-data-plot?id=${id}`,
        {
          key_metric: data,
        },
        'investor',
      )
      .then(res => {
        if (res.result) {
          dispatch(getInvestorMonthlyUpdatesMetricData(res.data))
          return res
        } else {
          if (res.error === 'token expired' && res.is_expired) {
            dispatch(fetchInvestorUserLogout())
            dispatch({
              type: 'SET_AUTH_EXPIRED',
            })
          }
          return false
        }
      })
  }
}

/** Retrieves the list of deals the investor has passed on. */
export const fetchInvestorPassedDeals = data => {
  return dispatch => {
    dispatch({
      type: actionTypes.MANAGE_BANK_ACCOUNT_INIT,
    })
    return api
      .post(
        `${process.env.REACT_APP_API_URL}/investor/get-passed`,
        {
          page_num: data,
          page_size: 10,
        },
        'investor',
      )
      .then(res => {
        if (res.result) {
          dispatch(getInvestorPassedDeals(res.data, res.total))
          return res
        } else {
          dispatch({
            type: actionTypes.MANAGE_BANK_ACCOUNT_FAILED,
          })
          if (res.error === 'token expired' && res.is_expired) {
            dispatch(fetchInvestorUserLogout())
            dispatch({
              type: 'SET_AUTH_EXPIRED',
            })
          }
          return false
        }
      })
  }
}

/** Reverts the action of passing on a deal for the investor. */
export const undoInvestorPassedDeals = data => {
  return dispatch => {
    return api
      .post(`${process.env.REACT_APP_API_URL}/investor/undo-pass-startup`, data, 'investor')
      .then(res => {
        if (res.result) {
          if (res.karma_points !== undefined) {
            dispatch({
              type: SET_PROFILE_DATA,
              payload: { data: { karma_points: res.karma_points } },
            })
          }
          return res
        } else {
          if (res.error === 'token expired' && res.is_expired) {
            dispatch(fetchInvestorUserLogout())
            dispatch({
              type: 'SET_AUTH_EXPIRED',
            })
          }
          return false
        }
      })
  }
}

/** Changes the investor's password using the provided data. */
export const changeInvestorPassword = data => {
  return dispatch => {
    return api
      .post(`${process.env.REACT_APP_API_URL}/investor/change-password`, data, 'investor')
      .then(res => {
        if (res.result) {
          return res
        } else {
          if (res.error === 'token expired' && res.is_expired) {
            dispatch(fetchInvestorUserLogout())
            dispatch({
              type: 'SET_AUTH_EXPIRED',
            })
          }
          return res
        }
      })
  }
}

/** Fetches the investor's email notification settings. */
export const fetchInvestorEmailNotification = () => {
  return dispatch => {
    return api
      .get(`${process.env.REACT_APP_API_URL}/investor/email-notification`, undefined, 'investor')
      .then(res => {
        if (res.result) {
          return res
        } else {
          if (res.error === 'token expired' && res.is_expired) {
            dispatch(fetchInvestorUserLogout())
            dispatch({
              type: 'SET_AUTH_EXPIRED',
            })
          }
          return res
        }
      })
  }
}

/** Saves the investor's email notification preferences. */
export const saveEmailNotification = data => {
  return dispatch => {
    return api
      .post(`${process.env.REACT_APP_API_URL}/investor/email-notification`, data, 'investor')
      .then(res => {
        if (res.result) {
          return res
        } else {
          if (res.error === 'token expired' && res.is_expired) {
            dispatch(fetchInvestorUserLogout())
            dispatch({
              type: 'SET_AUTH_EXPIRED',
            })
          }
          return res
        }
      })
  }
}

/** Retrieves notification data based on the provided parameters. */
export const getNotificationData = data => {
  return dispatch => {
    return api.post(`${process.env.REACT_APP_API_URL}/investor/notifications`, data, 'investor').then(res => {
      if (res.result) {
        return res
      } else {
        if (res.error === 'token expired' && res.is_expired) {
          dispatch(fetchInvestorUserLogout())
          dispatch({
            type: 'SET_AUTH_EXPIRED',
          })
        }
        return res
      }
    })
  }
}

/** Shares a deal with others using the provided data and deal ID. */
export const shareDeal = (data, id) => {
  return dispatch => {
    return api
      .post(`${process.env.REACT_APP_API_URL}/investor/share-deal?startup_id=${id}`, data, 'investor')
      .then(res => {
        if (res.result) {
          return res
        } else {
          if (res.error === 'token expired' && res.is_expired) {
            dispatch(fetchInvestorUserLogout())
            dispatch({
              type: 'SET_AUTH_EXPIRED',
            })
          }
          return res
        }
      })
  }
}

/** Fetches notification data for display in the dropdown menu. */
export const getNotificationDropdownData = data => {
  return dispatch => {
    return api
      .post(
        `${process.env.REACT_APP_API_URL}/investor/notification-dropdown`,
        {
          is_clicked: data,
        },
        'investor',
      )
      .then(res => {
        if (res.result) {
          return res
        } else {
          if (res.error === 'token expired' && res.is_expired) {
            dispatch(fetchInvestorUserLogout())
            dispatch({
              type: 'SET_AUTH_EXPIRED',
            })
          }
          return res
        }
      })
  }
}

/** Clears the investor's notifications. */
export const clearInvestorNotification = () => {
  return dispatch => {
    return api
      .post(
        `${process.env.REACT_APP_API_URL}/investor/notification-dropdown`,
        {
          is_clicked: true,
          clear: true,
        },
        'investor',
      )
      .then(res => {
        if (res.result) {
          return res
        } else {
          if (res.error === 'token expired' && res.is_expired) {
            dispatch(fetchInvestorUserLogout())
            dispatch({
              type: 'SET_AUTH_EXPIRED',
            })
          }
          return res
        }
      })
  }
}


/** Adds a new funding account with the provided data. */
export const addFundingAccount = data => {
  return async dispatch => {
    dispatch({
      type: actionTypes.ADD_FUNDING_ACCOUNT_INIT,
    })
    await api
      .postwithReqForm(`${process.env.REACT_APP_API_URL}/investor/add-funding-account`, data, 'investor')
      .then(res => {
        dispatch({
          type: actionTypes.ADD_FUNDING_ACCOUNT_SUCCESS,
          payload: res,
        })
        if (res.result) {
          return res
        } else {
          throw res.error
        }
      })
      .catch(error => {
        dispatch({
          type: actionTypes.ADD_FUNDING_ACCOUNT_FAILED,
          payload: error,
        })
        throw error
      })
  }
}

/** Deletes a bank account using the provided data. */
export const manageStripeBankAccount = (data, onSuccess, onError) => {
  return async dispatch => {
    dispatch({
      type: actionTypes.MANAGE_BANK_ACCOUNT_INIT,
    })
    await api
      .post(`${process.env.REACT_APP_API_URL}/investor/manage-bank-accounts`, data, 'investor')
      .then(res => {
        dispatch({
          type: actionTypes.MANAGE_BANK_ACCOUNT_SUCCESS,
          payload: res,
        })
        onSuccess && onSuccess(res)
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.MANAGE_BANK_ACCOUNT_SUCCESS,
        })
        onError(error?.response?.data?.error || error?.message)
        throw error?.response?.data?.error || error?.message
      })
  }
}

/** Fetches the investor's profile information. */
export const getInvestorProfile = onSuccess => {
  return async dispatch => {
    await api
      .get(`${process.env.REACT_APP_API_URL}/investor/profile`, undefined, 'investor')
      .then(res => {
        dispatch({
          type: SET_PROFILE_DATA,
          payload: res,
        })
        dispatch({
          type: 'INVESTOR_PROFILE_DATA',
          payload: res,
        })
        if (res.result && onSuccess) {
          onSuccess(res)
        }
        return res
      })
      .catch(error => {
        throw error?.response?.data?.error || error?.message
      })
  }
}

/** Marks the investor rationale modal as shown so it isn't displayed again. */
export const markInvestorRationaleShown = onSuccess => {
  return dispatch => {
    return api
      .get(`${process.env.REACT_APP_API_URL}/investor/investor-rationale-shown`, undefined, 'investor')
      .then(res => {
        if (res.result) {
          dispatch({
            type: 'TOGGLE_INVESTOR_RATIONALE_SHOWN',
          })
          if (onSuccess) {
            onSuccess(res)
          }
        }
        return res
      })
      .catch(error => {
        throw error?.response?.data?.error || error?.message
      })
  }
}

/** Submits (or skips) the investor's rationale for a given startup. */
export const submitInvestRationale = (data, onSuccess, onError) => {
  return dispatch => {
    return api
      .post(`${process.env.REACT_APP_API_URL}/investor/invest-rationale`, data, 'investor')
      .then(res => {
        if (res.result) {
          if (res.karma_points !== undefined) {
            dispatch({
              type: SET_PROFILE_DATA,
              payload: { data: { karma_points: res.karma_points } },
            })
          }
          onSuccess && onSuccess(res)
          return res
        } else {
          onError && onError(res)
          if (res.error === 'token expired' && res.is_expired) {
            dispatch(fetchInvestorUserLogout())
            dispatch({
              type: 'SET_AUTH_EXPIRED',
            })
          }
          return false
        }
      })
      .catch(error => {
        onError && onError(error)
        throw error?.response?.data?.error || error?.message
      })
  }
}

/** Submits investing step data for a specific entity identified by ID. */
export const postInvestingSteps = (data, id, onSuccess, onError) => {
  return async dispatch => {
    dispatch({
      type: actionTypes.POST_INVESTING_STEPS_INIT,
    })
    await api
      .post(`${process.env.REACT_APP_API_URL}/investor/investing-steps?id=${id}`, data, 'investor')
      .then(res => {
        if (res.result) {
          dispatch({
            type: actionTypes.POST_INVESTING_STEPS_SUCCESS,
            payload: res,
          })
          onSuccess && onSuccess(res)
          // return res
        } else {
          dispatch({
            type: actionTypes.POST_INVESTING_STEPS_FAILED,
          })
          onError(res?.error || 'Something went wrong please try again later.')
        }
      })
      .catch(error => {
        dispatch({
          type: actionTypes.POST_INVESTING_STEPS_FAILED,
        })
        onError(error?.response?.data?.error || error?.message)
        throw error?.response?.data?.error || error?.message
      })
  }
}

/** Initiates the process to invest money. */
export const investMoney = (onSuccess, onError) => {
  return async dispatch => {
    dispatch({
      type: actionTypes.GET_INVEST_MONEY_INIT,
    })
    await api
      .get(`${process.env.REACT_APP_API_URL}/investor/invest-money`, undefined, 'investor')
      .then(res => {
        if (res.result) {
          dispatch({
            type: actionTypes.GET_INVEST_MONEY_SUCCESS,
            payload: res,
          })
          if (onSuccess) {
            onSuccess(res)
          }
        } else {
          dispatch({
            type: actionTypes.GET_INVEST_MONEY_FAILED,
          })
          onError(res.error)
          throw res.error
        }
      })
      .catch(error => {
        dispatch({
          type: actionTypes.GET_INVEST_MONEY_FAILED,
        })
        onError(error.error)
        throw error
      })
  }
}

/** Retrieves the investment history based on provided criteria. */
export const fetchInvestmentHistory = (data, onSuccess) => {
  return async dispatch => {
    dispatch({
      type: actionTypes.GET_INVESTMENT_HISTORY_INIT,
    })
    await api
      .post(`${process.env.REACT_APP_API_URL}/investor/investment-history`, data, 'investor')
      .then(res => {
        dispatch({
          type: actionTypes.GET_INVESTMENT_HISTORY_SUCCESS,
          payload: res.data,
          totalCount: res.total,
          bankAccounts: res.bank_accounts,
          min_invested: res.min_invested,
          max_invested: res.max_invested,
        })
        onSuccess && onSuccess(res)
      })
      .catch(error => {
        dispatch({
          type: actionTypes.GET_INVESTMENT_HISTORY_FAILED,
        })
        throw error
      })
  }
}

/** Handles redirection to the portal. */
export const portalRedirection = (url = 'investor', data) => {
  return dispatch => {
    return api
      .post(
        `${process.env.REACT_APP_API_URL}/${url}/portal-redirection`,
        {
          portal: data,
        },
        url == 'education' ? 'learnInvest' : url == 'hiring' ? 'recruit' : url,
      )
      .then(res => {
        if (res.result) {
          return res
        } else {
          if (res.error === 'token expired' && res.is_expired) {
            dispatch(fetchInvestorUserLogout())
            dispatch({
              type: 'SET_AUTH_EXPIRED',
            })
          }
          return res
        }
      })
  }
}

/** Updates the type of investing selected by the user. */
export const updateInvestingType = (data, onSuccess, onError) => {
  return async dispatch => {
    dispatch({
      type: actionTypes.UPDATE_INVESTING_TYPE_INIT,
    })
    await api
      .patch(`${process.env.REACT_APP_API_URL}/investor/update-info`, data, 'investor')
      .then(res => {
        if (res.result) {
          dispatch({
            type: actionTypes.UPDATE_INVESTING_TYPE_SUCCESS,
            payload: res,
          })
          onSuccess && onSuccess(res)
          return res
        } else {
          dispatch({
            type: actionTypes.UPDATE_INVESTING_TYPE_FAILED,
          })
          onError(res.error)
        }
      })
      .catch(error => {
        dispatch({
          type: actionTypes.UPDATE_INVESTING_TYPE_FAILED,
        })
        throw error?.response?.data?.error || error?.message
      })
  }
}

/** Updates the user's selected business type. */
export const updateBusinessType = (data, onSuccess, onError) => {
  return async dispatch => {
    dispatch({
      type: actionTypes.UPDATE_BUSINESS_TYPE_INIT,
    })
    await api
      .patch(`${process.env.REACT_APP_API_URL}/investor/update-info`, data, 'investor')
      .then(res => {
        if (res.result) {
          dispatch({
            type: actionTypes.UPDATE_BUSINESS_TYPE_SUCCESS,
            payload: res,
          })
          onSuccess && onSuccess(res)
          return res
        } else {
          dispatch({
            type: actionTypes.UPDATE_BUSINESS_TYPE_FAILED,
          })
          onError(res.error)
        }
      })
      .catch(error => {
        dispatch({
          type: actionTypes.UPDATE_BUSINESS_TYPE_FAILED,
        })
        throw error?.response?.data?.error || error?.message
      })
  }
}

/** Adds data for post-investing steps with the specified step and its data. */
export const addPostInvestingStepsData = data => {
  const key = Object.keys(data)[0]
  const value = Object.values(data)[0]
  return {
    type: ADD_INVESTING_STEPS_DATA,
    payload: {
      step: key,
      data: value,
    },
  }
}

export const addAllPostInvestingStepsData = data => {
  return {
    type: ADD_ALL_INVESTING_STEPS_DATA,
    payload: data,
  }
}

export const removePostInvestingStepsData = () => {
  return {
    type: REMOVE_INVESTING_STEPS_DATA,
  }
}

/** Adds a new funding account with the provided data. */
export const addFundingAccount_NEW = (data, onSuccess) => {
  return async dispatch => {
    dispatch({
      type: actionTypes.ADD_FUNDING_ACCOUNT_INIT,
    })
    await api
      .postwithReqForm(`${process.env.REACT_APP_API_URL}/investor/add-funding-account`, data, 'investor')
      .then(res => {
        dispatch({
          type: actionTypes.ADD_FUNDING_ACCOUNT_SUCCESS,
          payload: res,
        })
        onSuccess && onSuccess(res)
        if (res.result) {
          return res
        } else {
          throw res.error
        }
      })
      .catch(error => {
        dispatch({
          type: actionTypes.ADD_FUNDING_ACCOUNT_FAILED,
          payload: error,
        })
        throw error
      })
  }
}

/** Fetches detailed information for a specific investor deal by ID. */
export const fetchInvestorDealDetailNew = (id, onSuccess, onError) => {
  return dispatch => {
    return api
      .post(
        `${process.env.REACT_APP_API_URL}/investor/startup-detail`,
        {
          id,
        },
        'investor',
      )
      .then(res => {
        if (res.result) {
          dispatch(getInvestorDealDetail(res.data))
        } else {
          if (res.error === 'token expired' && res.is_expired) {
            dispatch(fetchInvestorUserLogout())
            dispatch({
              type: 'SET_AUTH_EXPIRED',
            })
          }
        }
        onSuccess && onSuccess(res)
      })
      .catch(error => {
        onError && onError(error?.response?.data?.error || error?.message)
        throw error?.response?.data?.error || error?.message
      })
  }
}

// Action to get business classification categories
export const getTaxInformation = (data, onSuccess, onError) => {
  return async dispatch => {
    dispatch({
      type: actionTypes.GET_TAX_INFO_INIT,
    })
    await api
      .post(`${process.env.REACT_APP_API_URL}/investor/get-tax-info`, data, 'investor')
      .then(res => {
        dispatch({
          type: actionTypes.GET_TAX_INFO_SUCCESS,
          payload: res,
        })
        onSuccess && onSuccess(res)
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.GET_TAX_INFO_FAILED,
        })
        onError && onError(error?.response?.data?.error || error?.message)
        throw error?.response?.data?.error
      })
  }
}

// Action to Submit Tax Info
export const submitTaxInformation = (data, onSuccess, onError) => {
  return async dispatch => {
    dispatch({
      type: actionTypes.SUBMIT_TAX_INFO_INIT,
    })
    await api
      .post(`${process.env.REACT_APP_API_URL}/investor/submit-tax-info`, data, 'investor')
      .then(res => {
        dispatch({
          type: actionTypes.SUBMIT_TAX_INFO_SUCCESS,
          payload: res?.tax_info,
        })
        onSuccess && onSuccess(res)
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.SUBMIT_TAX_INFO_FAILED,
        })
        onError && onError(error?.response?.data?.error || error?.message)
        throw error?.response?.data?.error
      })
  }
}

export const handleShowTaxFlowSelectionScreen = () => {
  return { type: 'RESET_TAX_USER_TYPE' }
}

/** Uploads a tax form file with the provided data. */
export const taxFormFileUpload = (data, onSuccess, onFail) => {
  return async dispatch => {
    dispatch({
      type: actionTypes.TAX_FORM_FILE_UPLOAD_INIT,
    })
    await api
      .postwithFormData(
        `${process.env.REACT_APP_API_URL}/investor/tax-info-form-links-generator`,
        data,
        'investor',
      )
      .then(res => {
        if (res?.result) {
          dispatch({
            type: actionTypes.TAX_FORM_FILE_UPLOAD_SUCCESS,
            payload: res,
          })
          onSuccess && onSuccess(res)
          return
        } else {
          dispatch({
            type: actionTypes.TAX_FORM_FILE_UPLOAD_FAILED,
          })
          onFail && onFail(res?.error)
        }
      })
      .catch(error => {
        dispatch({
          type: actionTypes.TAX_FORM_FILE_UPLOAD_FAILED,
        })
        onFail && onFail(error?.response?.data?.error || error?.message)
        throw error?.response?.data?.error || error?.message
      })
  }
}

/** Retrieves accreditation information for the user. */
export const getAccreditationInfo = (onSuccess, onError) => {
  return async dispatch => {
    dispatch({
      type: actionTypes.GET_ACCREDITATION_INFO_INIT,
    })
    await api
      .get(`${process.env.REACT_APP_API_URL}/investor/accreditation-info`, undefined, 'investor')
      .then(res => {
        dispatch({
          type: actionTypes.GET_ACCREDITATION_INFO_SUCCESS,
          payload: res,
        })
        onSuccess && onSuccess(res)
        return res
      })
      .catch(error => {
        dispatch({
          type: actionTypes.GET_ACCREDITATION_INFO_FAILED,
        })
        onError && onError(error?.response?.data?.error || error?.message)
        throw error?.response?.data?.error || error?.message
      })
  }
}

// Action to Submit Accreditation Info
export const submitAccreditationInfo = (data, onSuccess, onError) => {
  return async dispatch => {
    dispatch({
      type: actionTypes.SUBMIT_ACCREDITATION_INFO_INIT,
    })
    await api
      .post(`${process.env.REACT_APP_API_URL}/investor/accreditation-info`, data, 'investor')
      .then(res => {
        dispatch({
          type: actionTypes.SUBMIT_ACCREDITATION_INFO_SUCCESS,
          payload: res,
        })
        onSuccess && onSuccess(res)
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.SUBMIT_ACCREDITATION_INFO_FAILED,
        })
        onError && onError(error?.response?.data?.error || error?.message)
        throw error?.response?.data?.error
      })
  }
}

export const stripeBasedVerifyIdentity = (onSuccess, onError) => {
  return async dispatch => {
    dispatch({
      type: actionTypes.STRIPE_VERIFY_IDENTITY_INIT,
    })
    await api
      .post(`${process.env.REACT_APP_API_URL}/investor/kyc-kyb-info`, {}, 'investor')
      .then(res => {
        dispatch({
          type: actionTypes.STRIPE_VERIFY_IDENTITY_SUCCESS,
          payload: res,
        })
        onSuccess && onSuccess(res)
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.STRIPE_VERIFY_IDENTITY_FAILED,
        })
        onError && onError(error?.response?.data?.error || error?.message)
        throw error?.response?.data?.error
      })
  }
}

export const stripeBasedFinancialConnections = (data, onSuccess, onError) => {
  return async dispatch => {
    dispatch({
      type: actionTypes.STRIPE_FINANCIAL_CONNECTIONS_INIT,
    })
    await api
      .post(`${process.env.REACT_APP_API_URL}/investor/add-funding-account`, data, 'investor')
      .then(res => {
        if (res.result) {
          dispatch({
            type: actionTypes.STRIPE_FINANCIAL_CONNECTIONS_SUCCESS,
            // payload: res,
          })
          onSuccess && onSuccess(res)
          return
        }
        dispatch({
          type: actionTypes.STRIPE_FINANCIAL_CONNECTIONS_FAILED,
        })
        onError && onError(res)
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.STRIPE_FINANCIAL_CONNECTIONS_FAILED,
        })
        onError && onError(error?.response?.data?.error || error?.message || error)
        throw error?.response?.data?.error
      })
  }
}

export const updateBankingInfoData = data => ({
  type: 'UPDATE_BANKING_INFO_DATA',
  payload: data,
})

/** Fetches the banking information. */
export const getBankingInfo = (onSuccess, onFail, data = {}) => {
  return async dispatch => {
    dispatch({
      type: actionTypes.GET_BANKING_INFO_INIT,
    })
    await api
      .post(`${process.env.REACT_APP_API_URL}/investor/banking-info`, data, 'investor')
      .then(res => {
        if (data.get_all == true) {
        } else {
          dispatch({
            type: actionTypes.GET_BANKING_INFO_SUCCESS,
            payload: res,
          })
        }
        onSuccess && onSuccess(res)
        return res
      })
      .catch(error => {
        dispatch({
          type: actionTypes.GET_BANKING_INFO_FAILED,
        })
        onFail && onFail(error?.response?.data?.error || error?.message)
        throw error?.response?.data?.error || error?.message
      })
  }
}

/** Create Investor Investment Profile. */
export const createInvestorInvestmentProfile = (data, onSuccess, onFail) => {
  return async dispatch => {
    dispatch({
      type: actionTypes.CREATE_INVESTOR_INVESTMENT_PROFILE_INIT,
    })
    await api
      .post(`${process.env.REACT_APP_API_URL}/investor/create-investor-investment-profile`, data, 'investor')
      .then(res => {
        dispatch({
          type: actionTypes.CREATE_INVESTOR_INVESTMENT_PROFILE_SUCCESS,
          payload: res,
        })
        onSuccess(res)
        return res
      })
      .catch(error => {
        dispatch({
          type: actionTypes.CREATE_INVESTOR_INVESTMENT_PROFILE_FAILED,
        })
        onFail(error?.response?.data?.error || error?.message)
        throw error?.response?.data?.error || error?.message
      })
  }
}

/** Update Investor Investment Profile. */
export const updateInvestorInvestmentProfile = (data, onSuccess, onFail) => {
  return async dispatch => {
    dispatch({
      type: actionTypes.UPDATE_INVESTOR_INVESTMENT_PROFILE_INIT,
    })
    await api
      .post(`${process.env.REACT_APP_API_URL}/investor/update-investor-investment-profile`, data, 'investor')
      .then(res => {
        if (res?.result === false) {
          dispatch({
            type: actionTypes.UPDATE_INVESTOR_INVESTMENT_PROFILE_FAILED,
          })
          onFail(res?.error || 'Something went wrong')
          return res
        }
        dispatch({
          type: actionTypes.UPDATE_INVESTOR_INVESTMENT_PROFILE_SUCCESS,
          payload: res,
        })
        onSuccess(res)
        return res
      })
      .catch(error => {
        dispatch({
          type: actionTypes.UPDATE_INVESTOR_INVESTMENT_PROFILE_FAILED,
        })
        onFail(error?.response?.data?.error || error?.message)
        throw error?.response?.data?.error || error?.message
      })
  }
}

export const addFundingAccountEuro = (data, onSuccess, onError) => {
  return async dispatch => {
    dispatch({
      type: actionTypes.ADD_FUNDING_ACC_EURO_INIT,
    })
    await api
      .post(`${process.env.REACT_APP_API_URL}/investor/add-funding-account`, data, 'investor')
      .then(res => {
        if (res.result) {
          dispatch({
            type: actionTypes.ADD_FUNDING_ACC_EURO_SUCCESS,
            // payload: res,
          })
          onSuccess && onSuccess(res)
          return
        }
        dispatch({
          type: actionTypes.ADD_FUNDING_ACC_EURO_FAILED,
        })
        onError && onError(res)
        return
      })
      .catch(error => {
        dispatch({
          type: actionTypes.ADD_FUNDING_ACC_EURO_FAILED,
        })
        onError && onError(error?.response?.data?.error || error?.message || error)
        throw error?.response?.data?.error
      })
  }
}
